module.exports = __webpack_public_path__ + "static/media/431933716_1496037251002286_4048239057433095686_n (1).d97485eb.jpg";